export const getIsLoadTestFromUrl = () => {
  const urlObject = new URL(window.location.href);

  return urlObject.searchParams.get('loadTest') === 'true';
};
